import { Input, InputRef } from 'antd';
import React, { forwardRef } from 'react';
import { formatDateInput, isValidDateString } from 'shared/utils/helpers/clientFormatDateInput';

// WORKS ONLY FOR CLIENT_DATE_FORMAT (DD.MM.YYYY) !!!!!!!!!
interface DatePickerInputProps {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  format?: string;
}

export const DatePickerInput = forwardRef<InputRef, DatePickerInputProps>((props, ref) => {
  const { value, onChange, disabled, placeholder } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const formatted = formatDateInput(e.target.value);

    onChange?.({
      ...e,
      target: {
        ...e.target,
        value: formatted,
      },
    });
  };

  const handleBlur = (): void => {
    if (!value) {
      return;
    }

    if (value.length === 10 && !isValidDateString(value)) {
      const emptyValue = {
        target: { value: '' },
      };

      onChange?.(emptyValue as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return <Input ref={ref} value={value} disabled={disabled} placeholder={placeholder} onChange={handleChange} onBlur={handleBlur} />;
});
